import React from "react";

const BRANDS = [
  "NIKE",
  "PEPSI",
  "PUMA",
  "AARP",
  "MCDONALD'S",
  "FACEBOOK",
  "INC 500",
  "Caesars Palace",
  "HYATT HOTELS",
  "OSCARS",
  "KIMPTON HOTELS",
  "WEWORK",
];

export default function BrandMarquee() {
  return (
    <section
      data-testid="brand-marquee-section"
      className="relative bg-stori-bg border-b border-stori-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10 lg:pt-28 lg:pb-14">
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[1.05] max-w-4xl">
          Used by the most savvy brands<span className="text-stori-cyan">.</span>
        </h2>
      </div>

      <div
        data-testid="brand-marquee"
        className="relative overflow-hidden border-t border-stori-border py-8 lg:py-10"
      >
        <div className="flex gap-16 animate-marquee whitespace-nowrap">
          {[...BRANDS, ...BRANDS].map((brand, i) => (
            <span
              key={i}
              className="font-heading text-2xl lg:text-3xl font-semibold tracking-[0.15em] text-stori-muted hover:text-white transition-colors"
            >
              {brand}
            </span>
          ))}
        </div>
        {/* Edge fades */}
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-stori-bg to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-stori-bg to-transparent pointer-events-none" />
      </div>
    </section>
  );
}
